import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.select = this.element.matches("select") ? this.element : this.element.querySelector("select")
    this.change = this.change.bind(this)
    this.select.addEventListener("change", this.change)
  }

  disconnect() {
    this.select?.removeEventListener("change", this.change)
  }

  change(event) {
    if (!event.target.value) return

    const url = new URL("/account/cooperation_bill_by_dept/fill_department_code", window.location.origin)
    url.searchParams.set("company_code", event.target.value)
    $.ajax(url.toString(), { dataType: "script" })
  }
}
